export const getMinutesInMs = (minutes: number): number => minutes * (60 * 1000);
export const getMinutesInSec = (minutes: number): number => minutes * (60 * 100);
export const getDaysInMs = (days: number): number => days * (60 * 1000 * 60 * 24);
export const getDaysInSec = (days: number): number => days * (60 * 1000 * 60 * 24);
